import React, { ComponentType } from 'react';

import BuilderLayout from 'layouts/BuilderLayout/BuilderLayout';

export const withBuilderUi =
  <T,>(Component: ComponentType<T>) =>
  (props: T): JSX.Element =>
    (
      <BuilderLayout>
        <Component {...props} />
      </BuilderLayout>
    );
